import { render, staticRenderFns } from "./AddPanduan.vue?vue&type=template&id=a787b768&"
import script from "./AddPanduan.vue?vue&type=script&lang=js&"
export * from "./AddPanduan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports